export default __webpack_public_path__ + "static/media/b_junta_de_directores_small.907cedd7.jpg";